import React from 'react';
import { ShieldCheck, Clock, Camera, HeartHandshake, MapPin } from 'lucide-react';
import { TRUST_SIGNALS } from '@/data/site';

const ICON_MAP = { ShieldCheck, Clock, Camera, HeartHandshake, MapPin };

export default function TrustSignals() {
  return (
    <section
      className="bg-ohana-surface border-y border-ohana-border"
      data-testid="trust-signals"
    >
      <div className="container-ohana py-6 md:py-8">
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4 md:justify-between">
          {TRUST_SIGNALS.map(({ label, icon }) => {
            const Ico = ICON_MAP[icon];
            return (
              <div
                key={label}
                className="flex items-center gap-3 text-ohana-primary"
                data-testid={`trust-${label.toLowerCase().replace(/[^a-z]+/g, '-')}`}
              >
                {Ico && <Ico className="h-5 w-5 text-ohana-accent" />}
                <span className="text-sm font-semibold tracking-wide">{label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
